// components/Footer/Footer.jsx
import { useState } from 'react';
import styles from './Footer.module.css'; // CSS-модуль

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Email submitted:', email);
    setEmail('');
  };

  return (
    <div className={styles.out_cont_footer}>
      <div className={styles.footer}>
        <div className={styles.container}>
          <div className={styles.logo}>
            <img src="/logo/logo_mini_256_256.png" alt="Manga Logo" width={50} height={50} />
            <span className={styles.logoText}>ManGO</span>
          </div>
          {/* <div className={styles.developers}>
            <h3>Разработчики</h3>
            <ul>
              <li>Иван Куксов</li>
              <li>Егор Леонов</li>
            </ul>
          </div> */}
          <div className={styles.contact}>
            <p><span className={styles.contact_title}>Почта для обращений: </span><span><a href="mailto:your-email@example.com">mango_project@mail.ru</a></span></p>
          </div>
        </div>
        <div className={styles.bottom} style={{color: "#242424"}}>
          {/* © {new Date().getFullYear()} ManGO. Все права защищены. */}
          версия сайта 1.1
        </div>
      </div>
    </div>
  );
};
